/**
 * 카드 프리셋 — Paper/Card 공통.
 * 사용처: ds.card(표 컨테이너 등 46곳), ds.cardPadded(KPI 카드 등 23곳).
 * 색상·간격은 반드시 tokens 에서 받는다 (하드코딩 금지).
 */
export const createCardPresets = (tokens) => ({
    /**
     * 기본 카드 — 주로 테이블을 감싸는 컨테이너.
     */
    card: {
        bgcolor: tokens.colors.surface,                    // 카드 면 색(흰색) — 페이지 배경(bg)과 구분되는 떠 있는 면
        border: `1px solid ${tokens.colors.border}`,       // elevation(그림자) 대신 테두리로 면을 구분하는 사내 톤
        borderRadius: 1,                                   // 8px — 표 컨테이너는 각지게 (노션풍 격자와 통일)
        /*
         * 세로: 카드는 스크롤하지 않는다 — 높이는 데이터 개수만큼 늘어나고 스크롤은 페이지(<main>)가 한다.
         * 가로: 넘치면 <b>카드 안에서 가로 스크롤</b>한다.
         *
         * [예전엔 overflowX: "clip" 이었고, 그게 버그였다]
         *   clip 은 스크롤 컨테이너를 만들지 않아 <b>넘친 부분을 볼 방법이 아예 없다</b>. 게다가 넘침을
         *   카드가 가둬버려 바깥 <main> 으로도 전달되지 않아, 가로 스크롤바가 어느 레벨에도 생기지 않았다.
         *   실제 피해: 지출요청 탭처럼 nowrap 열이 많은 표는 1280px 창 + 사이드바 펼침에서 오른쪽 열
         *   (금액 끝자리·상태 칩)이 잘린 채 확인할 방법이 없었다. table.js 의 minWidth:640 은 원래
         *   '가로 스크롤 유발' 장치인데 clip 과 만나면서 '무조건 잘림' 이 돼 있었다.
         *
         *   clip 을 택했던 근거는 "표 헤더 틀고정(sticky)이 깨진다" 였다. 그런데 이 코드베이스에는
         *   <b>sticky 표 헤더가 한 곳도 없다</b> — stickyHeader prop 도, thead 의 position:sticky 도
         *   쓰이지 않는다(전역 검색으로 확인). 즉 지킬 것이 없는 대가로 접근 불가를 감수하고 있었다.
         *
         * [주의] 나중에 표 헤더 틀고정을 도입한다면 이 값이 다시 문제가 된다. overflowX:auto 는 CSS 규칙상
         *   overflowY 도 auto 로 만들어(한쪽이 visible 이 아니면 다른 쪽 visible 은 무시된다) 카드가
         *   스크롤 컨테이너가 되기 때문이다. 그때는 카드가 아니라 <b>표만 감싸는 내부 래퍼</b>에 가로
         *   스크롤을 주고 헤더 고정 방식을 따로 설계할 것. (카드에 높이 제한이 없어 세로는 실제로 넘치지
         *   않으므로, 지금은 세로 스크롤바가 생기지 않는다.)
         */
        overflowX: "auto",
    },

    /**
     * 패딩 포함 카드 — KPI 숫자 카드, 요약 위젯처럼 내용물을 바로 담는 카드.
     */
    cardPadded: {
        bgcolor: tokens.colors.surface,
        border: `1.5px solid ${tokens.colors.border}`,
        borderRadius: 1.5,                                   // 16px — 위젯 카드는 부드럽게 (표 컨테이너와 의도적으로 다름)
        p: 2.5,                                            // 내부 여백 20px — 키우면 여유, 줄이면 정보 밀도 ↑
    },
});
